import context from '../context'
import getComponentKey from '@/utils/getComponentKey'

const initialState = {
  componentKey: getComponentKey(),
  fetching: false,
  updating: false,
  canAddWidget: false,
  items: []
}

const actionTypes = {
  Fetching: 'dashboard/fetching',
  Fetched: 'dashboard/fetched',
  Updating: 'dashboard/updating',
  Updated: 'dashboard/updated',
  Error: 'dashboard/error'
}

const actionCreators = {
  getDashboardWidgets: () => (dispatch) => {
    dispatch({ type: actionTypes.Fetching })
    context.api.dashboardService.getDashboardWidgets()
      .then(response => {
        dispatch({ type: actionTypes.Fetched, data: response })
      }).catch(() => dispatch({ type: actionTypes.Error }))
  },
  saveDashboardItem: (input) => (dispatch) => {
    dispatch({ type: actionTypes.Updating })
    context.api.dashboardService.saveDashboardItem(input)
      .then(() => {
        dispatch({ type: actionTypes.Updated })
        dispatch(actionCreators.getDashboardWidgets())
      }).catch(() => dispatch({ type: actionTypes.Error }))
  },
  deleteDashboardItem: (id) => (dispatch) => {
    dispatch({ type: actionTypes.Updating })
    context.api.dashboardService.deleteDashboardItem(id)
      .then(() => {
        dispatch({ type: actionTypes.Updated })
        dispatch(actionCreators.getDashboardWidgets())
      }).catch(() => dispatch({ type: actionTypes.Error }))
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.Fetching: return { ...state, fetching: true }
    case actionTypes.Fetched: return { ...state, fetching: false, canAddWidget: action.data.canAddWidget, items: action.data.items }
    case actionTypes.Updating: return { ...state, updating: true }
    case actionTypes.Updated: return { ...state, updating: false, componentKey: getComponentKey() }
    case actionTypes.Error: return { ...state, updating: false, fetching: false, componentKey: getComponentKey() }
    default: return state
  }
}

export { actionCreators, reducer }



// WEBPACK FOOTER //
// ./src/store/Dashboard.js